import { render } from "./VerifyEmailBody.vue?vue&type=template&id=230d9063"
import script from "./VerifyEmailBody.vue?vue&type=script&lang=js"
export * from "./VerifyEmailBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__